import { getStaticDocUrl } from "../utils/staticDocumentUrls"
import React from "react"

export var fr_BE = {
  /* ========================================== */
  /* COMMON =================================== */
  /* ========================================== */
  "Back to shop": "Retour au shop",
  "Redirecting to Samsung shop shortly": "Nous vous redirigeons vers le shop Samsung dans un instant",
  Back: "Retour",
  Validate: "Valider",
  "Your transaction is being finalized.": "Votre transaction est en cours de finalisation.",
  "Select...": "Sélectionner...",
  Choose: "Choisir",
  Start: "Commencer",
  Retry: "Reessayer",
  Continue: "Continuer",
  civility_mr: "M.",
  civility_mrs: "Mme",
  "Secure payment": "Paiement securise",
  "Payment validation": "Validation du paiement",
  "Validation de votre paiement en cours": "Validation de votre paiement en cours",
  "Complete your payment with Aplazame.": "Finalisez votre paiement avec Aplazame.",
  AplazameConfirmation: "Confirmation",
  "Complete your secure payment below.": "Finalisez votre paiement securise ci-dessous.",
  "Initializing secure payment...": "Initialisation du paiement securise...",
  "Unable to load payment configuration. Please try again.":
    "Impossible de charger la configuration du paiement. Merci de reessayer.",
  "Unable to start payment. Please try again.": "Impossible de demarrer le paiement. Merci de reessayer.",
  "Unable to submit payment. Please try again.": "Impossible d'envoyer le paiement. Merci de reessayer.",
  "A problem occurred during finalization. You will be redirected shortly.":
    "Un probleme est survenu pendant la finalisation. Vous allez etre redirige sous peu.",
  "Retry failed. Please try again.": "La nouvelle tentative a echoue. Merci de reessayer.",
  "Payment initialization is taking longer than expected. Please try again or contact support.":
    "L'initialisation du paiement prend plus de temps que prevu. Merci de reessayer ou de contacter le support.",
  Finalization: "Finalisation",
  "Bank card": "Carte bancaire",
  "Photo of your ID": "Photo de votre piece d'identite",
  "Your photo": "Votre photo",
  /* ========================================== */
  /* BREADCRUMB =============================== */
  /* ========================================== */
  Services: "Services",
  Informations: "Informations",
  "My informations": "Mes informations",
  Summary: "Récapitulatif",
  "My summary": "Mon récapitulatif",
  Contracts: "Contrats",
  Acceptance: "Acceptation",
  "Back to basket": "Retour au panier",
  /* ========================================== */
  /* BASKET =================================== */
  /* ========================================== */
  Basket: "Panier",
  "Promo code": "Code promo",
  on: "sur",
  months: "mois",
  months_uppercase: " Mois",
  Offered: "Offerts",
  "Shipping fees": "Frais de livraison",
  Upfront: "1er versement",
  "My upfront": "Mon 1er versement",
  Rent: "Loyer",
  "/month": "/mois",
  YYYY: "AAAA",
  "YYYY/MM/DD": "JJ/MM/AAAA",
  "DD/MM/YYYY": "JJ/MM/AAAA",
  "including services pack at": "dont pack de services à",
  "including services at": "dont services à",
  "Supporting documents requested": "Justificatifs demandés",
  "A bank card in your name": "Une carte bancaire à votre nom",
  "Your mobile phone": "Votre téléphone mobile",
  "A bank identity statement in your name": "Un relevé bancaire à votre nom",
  "My RIB": "Mon relevé bancaire",
  "Your banking credentials": "Vos identifiants bancaires (pour récupérer votre relevé bancaire)",
  "Mon relevé bancaire": "Mon relevé bancaire",
  "A valid ID in your name": "Une pièce d’identité valide à votre nom",
  "My ID": "Ma pièce d’identité",
  "My valid ID": "Ma pièce d’identité valide",
  "Proof of address of less than 3 months": "Un justificatif de domicile ≤ 3 mois",
  "Proof of address of less than 6 months": "Un justificatif de - de 6 mois",
  "My proof of address": "Mon justificatif de domicile",
  /* ========================================== */
  /* ONBOARDING PAGE ========================== */
  /* ========================================== */
  "My identification": "Mon identification",
  "Only if your bancary document's address is different than the one you will enter":
    "Uniquement si l’adresse sur mon RIB diffère de mon adresse actuelle",
  "Only if my RIB's address is different from my current address":
    "Uniquement si l'adresse de votre RIB diffère de votre adresse actuelle",
  "Enter the informations that will allow us to identify you.":
    "Entrez les informations nous permettant de vous identifier.",
  "Start your location online then meet us in our sellpoint.":
    "Démarrez votre demande de souscription en ligne puis rendez-vous en magasin.",
  "by entering my personnal informations": "en saisissant mes informations personnelles",
  "Want to rent my product ? No problem ! It only takes a few minutes to subscribe online":
    "Je souhaite louer mon produit ? Rien de plus simple ! Je fais ma demande en ligne en quelques minutes.",
  "Here are the steps to follow for your rental request !":
    "Voici les étapes à suivre pour votre demande de Location !",
  "Then i finalize my order in shop under 5 days, bringing with me those 3 proofs":
    "Puis je finalise en magasin dans les 5 jours en me munissant impérativement des 3 justificatifs suivants :",
  "To complete your subscription request, bring the following items, all of which must be in your name :":
    "Pour réaliser votre demande de souscription, munissez-vous des éléments suivants qui doivent tous être à votre nom :",
  "Here are the steps to follow to make your rental request":
    "Voici les étapes à suivre pour faire votre demande de location",
  "The online subscription procedure is fully dematerialized.":
    "La procédure de souscription en ligne est entièrement dématérialisée.",
  "The online subscription procedure is completely dematerialized. The signing of your contract and the sending of your supporting documents will be done electronically.":
    "La procédure de souscription en ligne est entièrement dématérialisée. La signature de votre contrat et l'envoi de vos pièces justificatives se feront de manière électronique.",
  "The signing of your contract and the downloading of your supporting documents will be done by electronic way.":
    "La signature de votre contrat et l'envoi de vos pièces justificatives se feront de manière électronique.",
  "Select your services and customize the options of your rental contract.":
    "Sélectionnez vos services et personnalisez les options de votre contrat de location.",
  "Pay by credit card the 1st installment of your rental contract.":
    "Payez par carte bancaire le 1er versement de votre contrat de location.",
  "through bank card to reserve my product": "par carte bancaire pour réserver mon produit",
  "Check and complete your personal information which will appear on your contract.":
    "Vérifiez et complétez vos informations personnelles qui figureront sur votre contrat.",
  "which will appear on my location's contract": "qui figureront sur mon contrat de location",
  "Validate your personal information and your rental request.":
    "Validez vos informations personnelles et votre demande de location.",
  "which allow me to validate my informations and my rent request":
    "qui me permet de valider mes informations et ma demande de location",
  "Download your supporting documents and sign your dematerialized contract.":
    "Téléchargez vos justificatifs et signez votre contrat dématérialisé.",
  "Obtain acceptance in principle then finalize your order in the store of your choice.":
    "Obtenez une acceptation de principe puis finalisez votre commande en magasin.",
  "I get a principle acceptation to rent my product":
    "J'obtiens une acceptation de principe pour la location de mon produit",
  "To complete your subscription request, have the following information ready:":
    "Pour réaliser votre demande de souscription, munissez-vous des éléments suivants :",
  "Only if the address of your RIB differs from your current address":
    "Uniquement si l’adresse de votre RIB diffère de votre adresse actuelle",
  /* ========================================== */
  /* SERVICES PAGE ============================ */
  /* ========================================== */
  "Gain peace of mind by protecting your product throughout the rental period.": "Services",
  "Read the insurance notice": "Lire la notice d’assurance",
  "Full warranty": "Garantie complète",
  Upgrade: "Renouvellement",
  "Dedicated customer service": "Service client dédié",
  "Accidental breakage": "Casse accidentelle",
  "Accidental oxidation": "Oxydation accidentelle",
  "Accidental action": "Action accidentelle",
  "Global coverage": "Couverture mondiale",
  "No deductible applied": "Aucune franchise appliquée",
  "14 days withdrawal period": "Délai de rétractation de 14j",
  "Telephone assistance 6 days a week": "Assistance téléphonique 6j/7",
  Pickpocketing: "Vol à la tire et à la sauvette",
  "Theft by assault or break-in": "Vol par agression ou effraction",
  "Fraudulent use": "Utilisation frauduleuse",
  None: "Aucun",
  Breakage: "Casse",
  "Breakage and theft": "Casse et vol",
  "or a rent of ": "soit un loyer de ",
  Cap: "Plafond",
  "2 claims maximum per insurance year. Ceiling 1500 € per insurance year.":
    "2 sinistres maximum par année d'assurance. Plafond 1500 € par année d'assurance.",
  "Main exclusions": "Principales exclusions",
  "The accessories, and connectors of the device. Normal wear and tear of the device. Negligence, forgetting the device. Theft from the primary and secondary residence.":
    "Les accessoires, et connecteurs de l’appareil. L'usure normale de l’appareil. La négligence, oubli de l’appareil. Le vol dans la résidence principale et secondaire.",
  "I acknowledge having read and accept the general conditions of the long-term rental contract offer and the service contract.":
    "Je reconnais avoir pris connaissance et accepte les conditions générales de l’offre de contrat de location longue durée et du contrat de services.",
  "I request the start of the execution of my long-term rental contract with the lessor and my service contract before the expiration of the 14-day withdrawal period.":
    "Je demande le commencement de l’exécution de mon contrat de location longue durée avec le loueur et de mon contrat de services avant l’expiration du délai de rétractation de 14 jours.",
  "I confirm that I do not choose optional insurance and assume the risk of breakage or theft during my long-term rental contract.":
    "Je confirme ne pas choisir l’assurance facultative et assume les risques de casse ou vol au cours de mon contrat de Location longue durée.",
  "I confirm my subscription to breakage insurance and acknowledge having read the insurance information notice.":
    "Je confirme mon adhésion à l’assurance casse et reconnais avoir pris connaissance de la notice d’information assurance.",
  "By checking this box, I authorize Cardif Assurances Risques Divers to use my email address for the execution of my contract. However, I recognize that certain documents must be sent to you in the original and that you will inform me if the case arises. I note that this data (email address) will not be used for commercial solicitation purposes, unless I have expressly consented otherwise. I have the right to oppose exchanges by e-mail at any time by sending my request to data.protection@cardif.com or to CARDIF Assurances Risques Divers - Claims quality department - Prévoyance SH 123- 8 rue du Port - 92 728 Nanterre Cedex.":
    "En cochant cette case, j’autorise Cardif Assurances Risques Divers à utiliser mon adresse électronique dans le cadre de l’exécution de mon contrat. Toutefois, je reconnais que certains documents doivent vous être obligatoirement envoyés en original et que vous m’en informerez si le cas se présente. Je prends acte que ces données (adresse électronique) ne seront pas utilisées à des fins de sollicitation commerciale, sauf si j’y ai expressément consenti par ailleurs. Je dispose de la faculté de m’opposer à tout moment aux échanges par courrier électronique en adressant ma demande à data.protection@cardif.com ou à CARDIF Assurances Risques Divers - Service qualité réclamations - Prévoyance SH 123- 8 rue du Port - 92 728 Nanterre Cedex.",
  'Up2You\'s breakage and thief protection is a collective damage insurance (number 674) contract subscribed by Samsung Electronics France, society with a capital of 27 000 000 euros – 334 367 497 RCS Bobigny – Siège social 1, rue fructidor 93484 Saint-Ouen auprès de CARDIF - Assurances Risques Divers - S.A. (society with a capital of 16 875 840 euros) 308 896 547 RCS Paris - Siège social : 1, Boulevard Haussmann 75009 Paris - Entreprise ruled by the insurance code, here called "CARDIF"':
    "«Protection casse et vol SAMSUNG Up2you location longue durée» est un contrat d’assurance collective de dommages n°674 souscrit par Samsung Electronics France, SAS au capital 27 000 000 euros – 334 367 497 RCS Bobigny – Siège social 1, rue fructidor 93484 Saint-Ouen auprès de CARDIF - Assurances Risques Divers - S.A. au capital de 16 875 840 € - 308 896 547 RCS Paris - Siège social : 1, Boulevard Haussmann 75009 Paris - Entreprise régie par le Code des assurances, ci-après dénommée « CARDIF ».",
  "Up2YOu Location's breakage and thief insurance is distributed as an accessory relatively to it main commercial activity by Samsung Electronics France by the way of Garantie-privée SAS, insurance society with a capital of 60 000 € - 521 279 737 RCS Bordeaux, - Siège social : 7-9 allée Haussmann 33300 Bordeaux, registered to l’ORIAS ( www.orias.fr ) under the reference 100 557 38.":
    "«Protection casse et vol SAMSUNG Up2you location longue durée» est distribué à titre accessoire à son activité commerciale principale par Samsung Electronics France par l’intermédiaire de Garantie-Privée SAS, Société de Courtage en assurances au capital de 60 000 € - 521 279 737 RCS Bordeaux, - Siège social : 7-9 allée Haussmann 33300 Bordeaux, immatriculée à l’ORIAS ( www.orias.fr ) sous le numéro 100 557 38 en sa qualité de Courtier.",
  "Up2You location breakage and thief contract' sinister handling is the responsability of Grantie-Privée, insurance broker":
    "La gestion des sinistres du contrat «Protection casse et vol SAMSUNG Up2you location longue durée» est déléguée à la société Garantie-Privée, en qualité de courtier gestionnaire.",
  "You have a 14-day cooling-off period for a remote rental request from the conclusion of your long-term rental contract. Non-contractual photo.":
    "Vous disposez d’un délai de rétractation de 14 jours pour une demande de location à distance à compter de la conclusion de votre contrat de location longue durée. Photos non contractuelles.",
  "You have not chosen an insurance option": "Vous n’avez pas choisi d’option assurance",
  "Be aware that in case of breakage or theft, you will have to pay for repairs to the product or its replacement. Remember to protect your device for peace of mind, as the breakdown guarantee does not cover breakage or theft.":
    "Sachez qu’en cas de casse ou de vol, vous devrez payer les réparations du produit ou son remplacement. Pensez à protéger votre appareil pour gagner en sérénité, d’autant que la garantie panne ne couvre pas la casse ou le vol*.",
  "*see general conditions in the insurance notice": "*voir conditions générales dans la notice d’assurance",
  /* ========================================== */
  /* UPFRONT PAGE ============================= */
  /* ========================================== */
  "first installment of your rental contract": "1er versement de votre contrat de location",
  "Cards accepted": "Cartes acceptées",
  "Cards not accepted": "Cartes non-acceptées",
  "Systematic authorization cards (Electron, Maestro, pre-paid or rechargeable), American Express and e-CB.":
    "Cartes à autorisation systématique (Electron, Maestro, pré-payées ou rechargeables), American Express et e-CB.",
  "This step only constitutes a request for authorization of payment.":
    "Cette étape ne constitue qu’une demande d’autorisation de paiement.",
  " The 1st payment of ": " Le 1er versement de ",
  " by credit card will only be effective after signing your rental contract and downloading your supporting documents.If your rental request is subsequently refused by the Lessor following its study, then this amount will be immediately refunded.":
    " par carte bancaire ne sera effectif qu’après le téléchargement de vos justificatifs et qu’après signature de votre Contrat de location. Si votre demande de location est par la suite refusée par le loueur suite à son étude, alors ce montant sera restitué.",
  "Systematically authorized cards (such as Electron, Maestro, prepaid, rechargeable), e-CB and American Express.":
    "Cartes à autorisation systématique (de type Electron, Maestro, prépayées, rechargeables), e-CB et American Express.",
  "Upfront amount of your leasing contract": "Montant du 1er versement de votre contrat de location",
  "Card number": "Numéro de carte",
  MM: "MM",
  CB: "CB",
  Visa: "Visa",
  Mastercard: "Mastercard",
  "Your credit card is expired": "Votre carte est expirée",
  "Expiration date": "Date d'expiration",
  CVV: "CVV (Bancontact: saisir 000)",
  "I, undersigned $ certify that I am the holder of the bank card used for the request for payment of my 1st payment.":
    [
      "Je soussigné(e) ",
      " certifie être le titulaire de la carte bancaire utilisée pour la demande d’autorisation de paiement de mon premier versement."
    ],
  "Secured payment": "Paiement sécurisé",
  "validate the payment authorization": "Valider l'autorisation de paiement",
  "Your card has been declined. Please check the accuracy of the information entered. You can also contact your bank to verify that it is not blocking payment.":
    "Votre carte a été refusée. Merci de vérifier l'exactitude des informations saisies. Vous pouvez également contacter votre banque pour vérifier qu'elle ne bloque pas le paiement.",
  /* ========================================== */
  /* CLIENT DATA PAGE ========================= */
  /* ========================================== */
  "Bank Seniority": "Année d'entrée dans votre banque actuelle",
  "My identity": "Mon identité",
  "My coordinates": "Mes coordonnées",
  "My situation": "Ma situation",
  "My budget": "Mon budget",
  "The information below is necessary for our renter for the constitution of your rental file.":
    "Les informations ci-dessous sont nécessaires à notre loueur pour la constitution de votre dossier de location.",
  "To meet our eligibility conditions, you must have regular activity income and not have any current payment incidents.":
    "Pour remplir nos conditions d’éligibilité, vous devez bénéficier d’un revenu d’activité régulier et ne pas avoir d’incidents de paiement en cours.",
  Identity: "Identité",
  Title: "Civilité",
  Mr: "M.",
  Ms: "Mme",
  "Last name": "Nom",
  "Maiden name": "Nom de naissance",
  "If you are not married, enter your name again.":
    "Si votre nom d’usage est votre nom de naissance, merci de le renseigner ici.",
  "First name": "Prénom",
  Address: "Adresse",
  "Enter the address that will appear on your contract.": "Saisissez l'adresse qui figurera sur votre contrat.",
  "Address 2": "Complément d'adresse (optionnel)",
  Locality: "Lieu dit (optionnel)",
  Zip: "Code postal",
  City: "Ville",
  Birth: "Naissance",
  Birthdate: "Date de naissance",
  "Department of birth": "Dpt. de naissance",
  "City of birth": "Ville de naissance",
  "Country of birth": "Pays de naissance",
  Citizenship: "Nationalité",
  Contact: "Contact",
  Mobile: "Numéro de mobile",
  Email: "Email",
  Occupation: "Profession",
  "Since...": "Depuis...",
  " since ": " depuis ",
  Finances: "Budget",
  "Your net monthly income": "Vos revenus mensuels nets",
  "over 12 months": "sur 12 mois",
  "over 13 months": "sur 13 mois",
  "over 14 months": "sur 14 mois",
  "over 15 months": "sur 15 mois",
  "over 16 months": "sur 16 mois",
  "Other monthly income": "Autres revenus mensuels",
  "Property income or alimony paid": "Revenus fonciers ou pension alimentaire reçue",
  "Your share of monthly charges": "Votre part de charges mensuelles",
  "Rent or mortgage": "Loyer ou crédit immobilier",
  "Rent or mortgage EVO":
    "Loyer(s) ou mensualité(s) des crédit(s) immobilier(s),  Crédit en cours hors immobilier, Frais de garde",
  "Net monthly income tooltip":
    "Salaire + prime(s), Retraite(s) et pré retraite(s), Revenus d’activité libérale, Pensions, ect…",
  "Other monthly charges": "Autres charges mensuelles",
  "Credit (excluding mortgage) and / or alimony paid": "Crédit (hors prêt immobilier) et/ou pension alimentaire versée",
  Housing: "Logement",
  "Family situation": "Situation familiale",
  "Number of dependent children": "Nb. d'enfants",
  "Bank account": "Compte bancaire",
  IBAN: "IBAN",
  "BIC or SWIFT": "BIC ou SWIFT",
  Included: "Inclus",
  /* ========================================== */
  /* SUMMARY ================================== */
  /* ========================================== */
  within: "sur",
  "Edit my data": "Modifier mes informations",
  "We ask your consent for all the purposes described in data processing :": " ",
  "I agree to receive Evollis' commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).":
    "J'accepte de recevoir les offres commerciales d'Evollis par voie électronique, ainsi que des communications numériques pour la performance de Samsung Care+ (dans le cas où j'ai souscrit à Samsung Care+).",
  "I oppose the receipt of commercial offers by mail or telephone from Evollis.":
    "Je m’oppose à la réception d'offres commerciales d'Evollis par voie postale ou par téléphone.",
  "I hereby declare that I have read the terms and conditions and the privacy policy and agree with their content": {
    elementHtml: (props) => {
      const hrefContract = getStaticDocUrl(
        props?.tunnelData,
        "contract",
        "https://static-samsung-be.evollis.com/pdf/contract_be.pdf"
      )
      const hrefPrivacy = getStaticDocUrl(
        props?.tunnelData,
        "privacy",
        "https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
      )
      return (
        <React.Fragment>
          {" "}
          Je déclare par la présente avoir lu les
          <a href={hrefContract} target="_blank" rel="noopener noreferrer" alt="">
            {" "}
            Conditions d'utilisation de la location{" "}
          </a>
          et de Samsung Care+, ainsi que le document d'information sur l'assurance (IPID), dans le cas où j'ai souscrit
          à Samsung Care+, et la{" "}
          <a href={hrefPrivacy} target="_blank" rel="noopener noreferrer" alt="">
            {" "}
            Politique de confidentialité
          </a>{" "}
          et accepter leur contenu. Je donne également l'autorisation de débiter le premier paiement unique pour le
          contrat de location de mon compte bancaire, et d'être débité des primes d'assurance mensuellement avec mon
          loyer, si j'ai opté pour la protection avec Samsung Care+.
        </React.Fragment>
      )
    }
  },

  "I hereby give my explicit consent to the processing of my personal data for the purposes specified in the privacy policy":
    {
      elementHtml: (props) => {
        const hrefPrivacy = getStaticDocUrl(
          props?.tunnelData,
          "privacy",
          "https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
        )
        return (
          <React.Fragment>
            {" "}
            Je donne par la présente mon consentement explicite au traitement de mes données personnelles aux fins
            spécifiées dans la
            <a href={hrefPrivacy} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Politique de confidentialité
            </a>
            .
          </React.Fragment>
        )
      }
    },

  "I agree to receive Evollis’ commercial offers electronically, as well as digital communications related to the performance of Samsung Care+ (if I have subscribed to it).":
    "J’accepte de recevoir les offres commerciales d’Evollis par voie électronique, ainsi que les communications numériques liées à la performance de Samsung Care+ (si j’y ai souscrit).",
  "I confirm that I have read and accepted the General Rental Terms and Conditions, the Privacy Policy, and, where applicable, the Samsung Care+ Terms of Use and the Insurance Product Information Document (IPID). I also authorize the debit of the initial one-time payment related to the rental agreement from my bank account, as well as the monthly debit of the insurance premiums together with the rent if I have subscribed to Samsung Care+ protection.":
    {
      elementHtml: (props) => {
        const hrefContract = getStaticDocUrl(
          props?.tunnelData,
          "contract",
          "https://static-samsung-be.evollis.com/pdf/contract_be.pdf"
        )
        const hrefPrivacy = getStaticDocUrl(
          props?.tunnelData,
          "privacy",
          "https://static-samsung-be.evollis.com/pdf/privacy_be.pdf"
        )
        return (
          <React.Fragment>
            {" "}
            Je confirme avoir pris connaissance et accepté les
            <a href={hrefContract} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Conditions Générales de Location,{" "}
            </a>
            la{" "}
            <a href={hrefPrivacy} target="_blank" rel="noopener noreferrer" alt="">
              {" "}
              Politique de confidentialité
            </a>{" "}
            ainsi que, le cas échéant, les Conditions Générales d'utilisation de Samsung Care+ et le document
            d’information sur l’assurance (IPID). J’autorise également le prélèvement du premier paiement unique relatif
            au contrat de location sur mon compte bancaire, ainsi que le prélèvement mensuel des primes d’assurance
            conjointement au loyer si j’ai souscrit à la protection Samsung Care+.
          </React.Fragment>
        )
      }
    },
  /* ========================================== */
  /* NETHEOS ================================== */
  /* ========================================== */
  "Read each document (tab), download your supporting documents. You will be able to accept the conditions of the contract by checking the boxes and electronically sign your contract with a code that you will receive by SMS.":
    "Prenez connaissance de chaque document (onglet), téléchargez vos justificatifs. Vous pourrez accepter les conditions du contrat en cochant les cases et signez électroniquement votre contrat par un code que vous allez recevoir par SMS.",
  "Your product will be delivered to you after the final acceptance of the long-term rental contract and upon receipt of supporting documents by the rental company.":
    "Votre produit vous sera livré après l’acceptation définitive du contrat de location longue durée et à réception des pièces justificatives par le loueur.",
  /* ========================================== */
  /* CONFIRMATION ============================= */
  /* ========================================== */
  "Request sent": "Demande envoyée",
  "Your file number is": "Votre numéro de dossier est le",
  "Now, we need to review it and determine if you are eligible for our offer. A response will be provided to you within 48 hours.":
    "Nous devons maintenant l’examiner et déterminer si vous êtes éligible à notre offre. Une réponse vous sera apportée dans un délai de 48h.",
  "Thank you for your trust and see you soon !": "Merci de votre confiance et à bientôt !",
  "Request pre-accepted": "Votre commande a été acceptée.",
  "Pre accepted paragraph one": {
    elementHtml: (
      <>
        N'oubliez pas d'imprimer votre bon de location et de le remettre au client. Ce bon de location sera également
        envoyé par e-mail.
      </>
    )
  },
  "Pre accepted paragraph two": {
    elementHtml: <></>
  },
  "Pre accepted paragraph three": {
    elementHtml: <small></small>
  },
  "Pre accepted paragraph four": {
    elementHtml: <>Remettre l'original du bon de livraison produit au client.</>
  },
  "Pre accepted paragraph five": {
    elementHtml: <>Faire l'upload du procès-verbal de livraison signé par le client.</>
  },

  /* ========================================== */
  /* ACCEPTANCE PAGE ========================== */
  /* ========================================== */
  lets_go: "N/A",
  you_have_x_days_to: {
    propsValues: (props) => {
      return `N/A`
    }
  },

  /* ========================================== */
  /* LEGALS =================================== */
  /* ========================================== */
  "Long-term rental contract, subject to acceptance of the file by the Lessor, Evollis, a Simplified Joint Stock Company under French law, with a capital of € {shareCapitalFinancer} , having its head office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Contrat de location longue durée, sous réserve d’acceptation du dossier par le Loueur, Evollis, Société par actions Simplifiée de droit français, au capital de {shareCapitalFinancer} €, ayant son siège social au 22 quai de Bacalan, 33300 Bordeaux, France, immatriculée au registre du commerce français sous le numéro 530612571; Numéro de TVA: FR 19530612571. N°ADEME : FR320894 _03JPOV.",
  "This is a long-term rental contract, which the consumer concludes with Evollis S.A.S. The consumer will first be asked to make a first payment and provide information. It is only after Evollis has evaluated this information and has definitively accepted the request, that the contract will be concluded. Evollis S.A.S. is a limited liability company under French law with its registered office at 22 quai de Bacalan, 33300 Bordeaux, France, registered in the French trade register under number 530612571; VAT number: FR 19530612571.":
    "Ceci est un contrat de location longue durée, que le consommateur conclut avec Evollis S.A.S. Le consommateur sera d'abord invité à effectuer un premier paiement et à fournir des informations. Ce n'est qu'après qu'Evollis a évalué ces informations et a définitivement accepté la demande, que le contrat sera conclu. Evollis S.A.S. est une société à responsabilité limitée de droit français ayant son siège social au 22 quai de Bacalan, 33300 Bordeaux, France, immatriculée au registre du commerce français sous le numéro 530612571; Numéro de TVA: FR 19530612571. . N°ADEME : FR320894 _03JPOV.",
  "The purpose of the information requested from you is to manage and execute your lease. Unless otherwise agreed, the provision of the requested information is mandatory. If the information provided is not complete, your rental request may be rejected. If you choose not to provide information, we will not be able to process your request. Your information is only intended for Evollis as manager and executor of the lease. By providing your information, you may receive commercial offers from our partners. If you want more information about the processing of your personal data by Evollis and your rights in this regard (access, rectification, deletion, limitation of processing, data transfer, get it here. You can also contact us at our postal address: Evollis, Customer Service, 22 quai de Bacalan, 33300 Bordeaux, France or by e-mail: protectiondonnees@evollis.com":
    "Le but des informations qui vous sont demandées est de gérer et d'exécuter votre bail. Sauf convention contraire, la fourniture des informations demandées est obligatoire. Si les informations fournies ne sont pas complètes, votre demande de location pourra être rejetée. Si vous choisissez de ne pas fournir d'informations, nous ne serons pas en mesure de traiter votre demande. Vos informations ne sont destinées qu'à Evollis en tant que gérant et exécuteur du bail. En fournissant vos informations, vous pouvez recevoir des offres commerciales de nos partenaires. Si vous souhaitez plus d'informations sur le traitement de vos données personnelles par Evollis et sur vos droits à cet égard (accès, rectification, suppression, limitation du traitement, transfert de données, options d'opposition et gestion de vos données après décès), vous pouvez l'obtenir ici. Vous pouvez également nous contacter à notre adresse postale: Evollis, Service Client, 22 quai de Bacalan 33300 Bordeaux, France ou par email: protectiondonnees@evollis.com",
  /* Mentions légales tenants (clés alignées sur voyager-script) */
  mediamarkt_legal_mention_0:
    "Contrat de location longue durée (LLD), sous réserve d’acceptation du dossier par le Loueur, Evollis, Société par Actions Simplifiée au capital de {shareCapitalFinancer} €, dont le siège social est situé 22-26 quai de Bacalan, 33300 Bordeaux, France, immatriculée au RCS de Bordeaux sous le numéro 530 612 571, TVA intracommunautaire FR 19 530612571. N° ADEME : FR320894_03JPOV.",
  mediamarkt_legal_mention_1:
    "La demande de location implique la réalisation d’un premier versement et la fourniture d’informations nécessaires à l’étude du dossier. Le contrat de location ne sera définitivement formé qu’après examen et acceptation du dossier par Evollis. En cas de refus de la demande de location par Evollis, toute somme versée sera intégralement remboursée dans les meilleurs délais.",
  mediamarkt_legal_mention_2: {
    propsValues: (props) => {
      const hrefPrivacy = getStaticDocUrl(
        props?.tunnelData,
        "privacy",
        "https://static-evollis.evollis.com/mediamarkt_be/fr-BE/privacy.pdf"
      )
      return (
        "Les données personnelles collectées sont nécessaires à l’étude de la demande et à la gestion du contrat de location. " +
        "Les traitements réalisés à ces fins reposent sur l’exécution du contrat. " +
        "Les traitements réalisés à des fins de prospection commerciale de partenaires reposent sur votre consentement, que vous pouvez retirer à tout moment. " +
        "Pour en savoir plus sur le traitement de vos données personnelles et sur vos droits (accès, rectification, effacement, limitation, opposition et portabilité), " +
        `vous pouvez consulter la Notice d’information relative à la protection des données personnelles en <a href="${hrefPrivacy}" target="_blank" rel="noopener noreferrer">cliquant ici</a>.`
      )
    }
  },
  mediamarkt_legal_mention_3:
    "Vous pouvez également contacter Evollis à l’adresse suivante :\n" +
    "Evollis – Service Client\n" +
    "22 quai de Bacalan\n" +
    "33300 Bordeaux, France\n" +
    "\n" +
    "ou par e-mail à l’adresse support.mediamarkt@evollis.com",
  /* ========================================== */
  /* ERROR PAGES ============================== */
  /* ========================================== */
  "Internal error": "Erreur interne",
  "The server was unable to process your request.": "Le serveur n'a pas pu traiter votre requête.",
  "The server has encountered an error, and couldn't treat your request.":
    "Le serveur a rencontré une erreur et n’a pas été en mesure de traiter votre requête.",
  "Page not found": "Page introuvable",
  "The page you're asking for doesn't exist or had been deleted":
    "La page que vous recherchez n’existe pas ou a été supprimée.",
  "Service unavailable": "Service indisponible",
  "Service is unavailable, please come back later.":
    "Le service est temporairement indisponible. Merci de revenir plus tard.",
  "Pending request": "Demande en attente",
  "We will send you an email allowing you to finalize your file later.":
    "Nous allons vous envoyer un email vous permettant de finaliser votre dossier plus tard.",
  adyen_first_payment_intro:
    "Nous vous demandons d'effectuer un premier paiement correspondant aux frais uniques prévus par votre contrat Private Lease. Soit",
  adyen_first_payment_review:
    "Une fois votre premier paiement reçu et votre demande déposée, Evollis étudiera votre demande. Evollis pourra vous demander de fournir des informations complémentaires. Le contrat Private Lease ne prendra effet qu'après l'acceptation définitive de votre demande par Evollis. Si vous n'êtes pas éligible au Private Lease, le premier paiement vous sera remboursé. Vous disposez également du droit de résilier gratuitement le contrat dans les 14 jours suivant le dépôt de votre demande ; dans ce cas, le premier paiement vous sera également remboursé.",
  adyen_first_payment_provider:
    "Le premier paiement sera effectué via iDEAL par notre prestataire de services Adyen. Adyen B.V. est une société à responsabilité limitée enregistrée auprès de la Chambre de commerce sous le numéro 34259528, dont le siège social est situé Simon Carmiggeltstraat 6-50, 1011 DJ Amsterdam, Pays-Bas.",
  "Without your supporting documents, your file will be canceled within 3 days.":
    "Sans vos pièces justificatives, votre dossier sera annulé dans un délai de 3 jours.",
  /* ========================================== */
  /* VALIDATION =============================== */
  /* ========================================== */
  "Not a valid IBAN": "IBAN invalide",
  "Not a valid BIC": "BIC invalide",
  Required: "Champ requis",
  "Enter data": "Saisir les données",
  "Invalid data": "Données incorrectes",
  pdi_retail_opl: "Numéro de commande",
  pdi_retail_store_id_label: "Numéro de magasin",
  pdi_retail_partner_order_id_label: "Numéro de commande distributeur*",
  pdi_retail_imei_marquage_label: "IMEI / Numéro de série",
  pdi_retail_mm_order_digits: "Saisissez exactement 8 chiffres.",
  "Date is not valid": "Date invalide",
  Maximum: "Maximum",
  characters: "caractères",
  "maximum characters": "caractères maximum",
  "Unauthorized characters": "Caractères non-autorisés",
  "Phone number must start with 06 or 07 and contain 10 numbers":
    "Le numéro de téléphone doit commencer par 06 ou 07 et contenir 10 numéros",
  "Invalid phone number": "Numéro invalide",
  "Invalid postal code": "Code postal invalide",
  "Minimum age must be > 18 years old": "L'âge minimum doit être > 18 ans",
  "Maximum age must be < 110 years old": "L'âge maximum doit être < 110 ans",
  "Must be positive": "Le nombre doit être positif",
  "minimum characters": "caractères minimum",
  "number of children must be contains between 0 and 10": "Le nombre d'enfants doit être compris entre 0 et 10",
  "birthDate is not valid": "Date de naissance invalide",
  "employmentDate cannot be before birthDate": "La date d'embauche ne peut pas être avant la date de naissance",
  "Year seniority bank cannot be before birth date":
    "La date d'ancienneté bancaire ne peut pas être avant la date de naissance",
  "difference between employment date and birth date must be at least 16 years":
    "La différence entre la date d'embauche et de naissance doit être d'au moins 16 ans",
  "difference between bank seniority date and birth date must be at least 16 years":
    "La différence entre la date d'ancienneté bancaire et la date de naissance doit être d'au moins 16 ans",
  "employmentDate cannot be in future": "La date d'embauche ne peut pas être dans le futur",
  "Must be a whole number": "Doit être un nombre entier",
  "Must be a number": "Doit être un nombre",
  "Email invalid": "Adresse mail invalide",
  "Please assert you're the real card owner": "Cochez pour confirmer être le propriétaire de cette carte de paiement",
  "Not a valid MM value": "Mois au format MM requis",
  "Not a valid YYYY date": "Année au format AAAA requise",
  "Not a valid date": "Date invalide",
  "Can't be before current year": "Ne peut pas être avant l'année actuelle",
  "Must be composed of 3 digits": "Doit être composé de 3 chiffres",
  "Must be composed of 12-19 digits": "Doit être composé de 12-19 chiffres",
  "Not a valid YYYY-MM-DD date": "Entrez une date au format JJ/MM/AAAA",
  "Residence date cannot be before birth date": "La date de résidence ne peut pas être avant la date de naissance",
  "This date cannot be in future": "Cette date ne peut pas être dans le futur",
  "Employment date cannot be before birth date": "La date d'embauche ne peut pas être avant la date de naissance",
  "Employment date cannot be in future": "La date d'embauche ne peut pas être dans le futur",
  "Please pick a correct value": "Choisissez une valeur correcte",
  validator_invalidNetMounthlyIncomeFormat: "N/A",
  validator_endContractDateInFuture: "N/A",
  /* ========================================== */
  /* OK KO BACK =============================== */
  /* ========================================== */
  "Your request is already finalized": "Votre demande est déjà finalisée",
  "You will receive a final response within 24 hours.": "Votre recevrez une réponse définitive sous 24h.",
  "Thank you for your request.": "Nous vous remercions pour votre demande.",
  "Your request has already been validated": "Votre demande a déjà été validée",
  "The information you have entered can no longer be changed.":
    "Les informations que vous avez saisies ne peuvent plus être modifiées.",
  "Please click on the button below to finalize your order.":
    "Merci de cliquer sur le bouton ci dessous pour finaliser votre commande.",
  "Finalize your order": "Finalisez votre commande",
  "Operation failed": "Echec de votre demande",
  "Your order is canceled. The amount of the upfront will not be deducted from you.":
    "Votre commande est annulée. Le montant de l'apport ne vous sera pas prélevé.",
  "Your order has been cancelled.": "Votre commande a été annulée.",
  please_study_other_payment_means: " ",
  "Request denied": "Demande refusée",
  "We regret to inform you that we cannot give a favorable response to your request.":
    "Nous sommes au regret de vous informer que nous ne pouvons pas donner une suite favorable à votre demande.",
  Maintenance: "Maintenance",
  "The app is temporarily unavailable.": "L'application est temporairement indisponible.",
  "Please come back later.": "Merci de revenir plus tard.",
  "New Order": "Nouvelle commande",
  "Renew Order": "Renouveller mon contrat",
  "Print the rental voucher": "Imprimer le bon de location",
  generate_delivery_voucher: "Générer le bon de livraison",
  voucher_ready:
    "N'oubliez pas d'imprimer votre bon de location et de le remettre au client ; celui-ci sera également envoyé au client par e-mail.",
  error_voucher_retrieval: "Une erreur s'est produite lors de la récupération du bon de location.",
  "No rental voucher": "Aucun bon de location disponible",
  imei: "IMEI / Numéro de série",
  numero_marquage: "Numéro de marquage",
  final_page_import_document: "Télécharger un document",
  finalize_later: "Finaliser plus tard",
  document_type: "Type de document",

  /* ========================================== */
  /* LOGIN ================================== */
  /* ========================================== */
  "Bad credentials": "n/a",
  username: "n/a",
  password: "n/a",
  connect: "n/a",
  "need help": "n/a",
  "login page need help tooltip": "n/a",
  "User account is locked": "n/a",

  /* ========================================== */
  /* RESET PASSWORD  ========================== */
  /* ========================================== */
  password_expired: "n/a",
  old_password: "n/a",
  new_password: "n/a",
  verify_new_password: "n/a",
  change_password: "n/a",
  confirmation_password_matches_new_password: "n/a",
  old_password_matches_current_password: "n/a",
  different_password: "n/a",

  /* ========================================== */
  /* RETAIL ================================== */
  /* ========================================== */
  TOUS: "Tous",
  WAIT_SIGNATURE: "Attente signature",
  WAITING_DOCUMENTS: "Attente documents",
  REJECTED: "Rejetée",
  PJ_UPLOADES: "PJ Uploadés",
  ACCEPTED_AWAITING_FUNDING: "Acceptée - Attente financement",
  NOT_FINALIZED: "Non finalisée",
  A_TRAITER_OCTROI: "À traiter octroi",
  REFUSED_AFTER_DOCUMENT_ANALYSIS: "Refusé après analyse des documents",
  DEFAULT: "DEFAULT n/a",
  wrongFileExtensionMessage: "Ce fichier n'est pas conforme, vous devez choisir une image jpg ou un pdf.",
  onlyAlphaNumericMessage: "Le nom ne doit contenir que des caractères alphanumériques",
  fiveMegaBytesMaximumFileMessage: "Le fichier dépasse sa taille maximale autorisée de 5 MB.",
  retail_patch_order_success_label: "Votre numéro a bien été enregistré.",

  resume_order_fill_shipping_date_button_label: "Saisir une date de livraison",

  one_lower_case_required: "n/a",
  one_upper_case_required: "n/a",
  one_number_required: "n/a",
  more_than_height_length: "n/a",
  previous: "n/a",
  next: "n/a",
  save: "n/a",
  change_identity_bloc_simplified_journey:
    "Si vous souhaitez modifier les données présentes dans “Mon identité”, merci de contacter notre service client à l’adresse suivante {adresse}",
  /* Algoan Bank Modal */
  algoanBankModal_loadingAria: "Chargement",
  algoanBankModal_loadingText: "Récupération de vos comptes bancaires...",
  algoanBankModal_errorMessage: "Une erreur s'est produite, merci de ressayer ultérieurement.",
  algoanBankModal_retry: "Réessayer",
  algoanBankModal_titleSingle: "Le compte bancaire sur lequel vous serez prélévé de vos mensualités",
  algoanBankModal_titleMultiple:
    "Choisissez le compte bancaire sur lequel vous souhaitez être prélévé de vos mensualités",
  algoanBankModal_continue: "Continuer",
  algoanBankModal_noAccount: "Nous n'avons pas pu identifier de compte bancaire à votre nom.",
  algoanBankModal_noAccountAdvice:
    "Merci de faire un nouveau parcours et d'utiliser un compte bancaire dont vous êtes bien le propriétaire.",
  button_close: "Fermer",
  /* Algoan Open Banking error codes */
  algoanBankModal_CURRENCY_NOT_SUPPORTED_title: "Devise non compatible",
  algoanBankModal_CURRENCY_NOT_SUPPORTED_message:
    "Nous ne pouvons pas analyser votre compte bancaire car la devise de votre compte n'est pas compatible avec notre service. Merci d'utiliser un compte en euros.",
  algoanBankModal_NO_CHECKING_ACCOUNT_title: "Aucun compte courant détecté",
  algoanBankModal_NO_CHECKING_ACCOUNT_message:
    "Nous n'avons pas détecté de compte courant à votre nom. Merci d'utiliser un compte bancaire courant pour poursuivre votre demande.",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_title: "Type de compte inconnu",
  algoanBankModal_ACCOUNT_TYPE_NOT_SUPPORTED_message:
    "Le type de compte bancaire détecté n'est pas compatible avec notre analyse. Merci d'utiliser un compte bancaire classique.",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_title: "Client non titulaire (procuration)",
  algoanBankModal_OWNERSHIP_NOT_SUPPORTED_message:
    "Le compte bancaire utilisé ne semble pas être à votre nom. Merci d'utiliser un compte dont vous êtes le titulaire.",
  algoanBankModal_USAGE_NOT_SUPPORTED_title: "Compte professionnel",
  algoanBankModal_USAGE_NOT_SUPPORTED_message:
    "Les comptes professionnels ne sont pas acceptés. Merci d'utiliser un compte bancaire personnel.",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_title: "Pas assez de transactions",
  algoanBankModal_NOT_ENOUGH_TRANSACTIONS_message:
    "Nous ne disposons pas d'un historique bancaire suffisant pour analyser votre situation. Merci d'utiliser un compte comportant des transactions récentes.",
  algoanBankModal_UNKNOWN_title: "Cas non identifié",
  algoanBankModal_UNKNOWN_message:
    "Une erreur est survenue lors de l'analyse de votre compte bancaire. Merci de réessayer ultérieurement."
}
